module.exports = __webpack_public_path__ + "static/img/ic_delete.556486ea.svg";